interface TruncateOptions {
  stripTags?: boolean;
  words?: boolean;
  noBreaks?: boolean;
  length?: number;
  ellipsis?: string;
  truncated?: boolean;
}

// Matches trailing non-space characters.
const chop = /(\s*\S+|\s)$/;

const truncateDefaults: Required<TruncateOptions> = {
  stripTags: false,
  words: false,
  noBreaks: false,
  length: Infinity,
  ellipsis: "\u2026",
  truncated: false,
};

export const truncateHTML = (
  html: string,
  options: TruncateOptions | number = {},
): string => {
  const div = document.createElement("div");
  div.innerHTML = html;

  const element = truncateElement(div, options);
  return element.innerHTML;
};

const truncateElement = (
  element: HTMLElement,
  options: TruncateOptions | number = {},
): HTMLElement => {
  if (typeof options === "number") {
    options = { length: options };
  }

  const o: Required<TruncateOptions> = { ...truncateDefaults, ...options };

  // if (o.noBreaks) self.find('br').replaceWith(' ');
  if (o.noBreaks) {
    const brElements = element.querySelectorAll("br");
    brElements.forEach((br) => {
      const textNode = document.createTextNode(" ");
      br.parentNode?.replaceChild(textNode, br);
    });
  }

  // var text = self.text();
  const text = element.textContent || "";

  // var excess = text.length - o.length;
  let excess = text.length - o.length;

  // if (o.stripTags) self.text(text);
  if (o.stripTags) {
    element.innerHTML = "";
    element.textContent = text;
  }

  // Chop off any partial words if appropriate.
  if (o.words && excess > 0) {
    const truncatedText = text.slice(0, o.length);
    const chopped = truncatedText.replace(chop, "");
    excess = text.length - chopped.length - 1;
  }

  // if (excess < 0 || !excess && !o.truncated) return;
  if (excess < 0 || (!excess && !o.truncated)) {
    return element;
  }

  // Iterate over each child node in reverse, removing excess text.
  const childNodes = Array.from(element.childNodes).reverse();

  for (let i = 0; i < childNodes.length; i++) {
    const el = childNodes[i];
    const textContent = el.textContent || "";
    const length = textContent.length;

    // If the text is longer than the excess, remove the node and continue.
    if (length <= excess) {
      o.truncated = true;
      excess -= length;
      el.parentNode?.removeChild(el);
      continue;
    }

    // Remove the excess text and append the ellipsis.
    if (el.nodeType === 3) {
      // TEXT_NODE
      const textNode = el as Text;
      const splitIndex = length - excess - 1;

      if (splitIndex >= 0) {
        const afterSplit = textNode.splitText(splitIndex);
        const ellipsisNode = document.createTextNode(o.ellipsis);
        afterSplit.parentNode?.replaceChild(ellipsisNode, afterSplit);
      }
      break;
    }

    // Recursively truncate child nodes.
    if (el.nodeType === 1) {
      // ELEMENT_NODE
      const childElement = el as HTMLElement;
      const childOptions: Required<TruncateOptions> = {
        ...o,
        length: length - excess,
      };
      truncateElement(childElement, childOptions);
      break;
    }
  }

  return element;
};
